import type { Location } from 'modules/core/lib/navigation/types'

export const myExpenses = {
  path: 'my-expenses',
  children: {
    list: {
      path: 'list',
      size: 'full',
      children: {
        expenses: {
          path: 'expenses',
          size: 'full',
          children: {
            new: {
              path: 'new',
              size: 'full',
            },
            newExpenseOcr: {
              path: 'new-expense-ocr',
              size: 'full',
            },
            newMileage: {
              path: 'new-mileage',
              size: 'full',
            },
            newPerDiem: {
              path: 'new-per-diem',
              size: 'full',
            },
            newGroup: {
              path: 'new-group',
              size: 'full',
            },
            expenseId: {
              path: ':expense_id',
              size: 'full',
            },
            exporter: {
              path: 'exporter',
              size: 'full',
            },
          },
        },
        groups: {
          path: 'groups',
          size: 'full',
          children: {
            new: {
              path: 'new',
              size: 'full',
            },
            newExpenseOcr: {
              path: 'new-expense-ocr',
              size: 'full',
            },
            newMileage: {
              path: 'new-mileage',
              size: 'full',
            },
            newPerDiem: {
              path: 'new-per-diem',
              size: 'full',
            },
            newGroup: {
              path: 'new-group',
              size: 'full',
            },
          },
        },
      },
    },
    groups: {
      path: 'groups',
      size: 'full',
      children: {
        id: {
          path: ':groupId',
          size: 'full',
          children: {
            edit: {
              path: 'edit',
              size: 'full',
            },
            new: {
              path: 'new',
              size: 'full',
            },
            newExpenseOcr: {
              path: 'new-expense-ocr',
              size: 'full',
            },
            newMileage: {
              path: 'new-mileage',
              size: 'full',
            },
            newPerDiem: {
              path: 'new-per-diem',
              size: 'full',
            },
            expenseId: {
              path: ':expense_id',
              size: 'full',
            },
          },
        },
      },
    },
    cards: {
      path: 'cards',
      children: {
        list: {
          path: 'list',
          children: {
            cardId: {
              path: ':cardId',
            },
          },
        },
        requestCard: {
          path: 'request-card',
        },
        cardId: {
          path: ':cardId',
          level: 2,
        },
      },
    },
  },
} as const satisfies Location

export const myCards = {
  path: 'my-cards',
  children: {
    requestCard: {
      path: 'request-card',
    },
    cardId: {
      path: ':cardId',
      level: 1,
    },
  },
} as const satisfies Location
